<div class="filter-section-wrapper">
  <div id="top-section">
    <ng-container *ngTemplateOutlet="topSolo"></ng-container>
  </div>
  <div id="second-level">
    <ng-container *ngTemplateOutlet="secondLevel"></ng-container>
  </div>
  <div id="bottom-section-split">
    <div id="other">
      <ng-container *ngTemplateOutlet="bottomLeft"></ng-container>
    </div>
    <div id="buttons">
      <ng-container *ngTemplateOutlet="bottomRight"></ng-container>
    </div>
  </div>
  <div id="bottom-section-solo">
    <ng-container *ngTemplateOutlet="bottomSolo"></ng-container>
  </div>
</div>
